module.exports = __webpack_public_path__ + "img/master21.bcd1148a.png";